import React, { useEffect, useState } from 'react';
import { Form, Radio, Tag, Input, Space, Checkbox } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import '../SurveyAnswer.less';

// 选择列表
const SelectList = ({ body, required, id, isMultipleChoice, optionList, num, minSelect, maxSelect, form, initForm }: { body?: string; required?: boolean; optionList?: Array<string>; num?: number; id?: number; minSelect?: number; maxSelect?: number; form?: any; initForm?: any; isMultipleChoice?: any }) => {
    const [value, setValue] = useState<any>([]);
    const [options, setOptions] = useState<any>([]);

    const [showSearch, setShowSearch] = useState(false);
    const [searchOptions, setSearchOptions] = useState<any>([]);
    const [searchVal, setSearchVal] = useState('');

    const handleChange = (check: any) => {
        if (isMultipleChoice) {
            setValue(check);
            form.setFieldValue(`${id}-13`, check);
        } else {
            const singleRadio = check.target.value;
            if (singleRadio) {
                setValue(singleRadio);
                form.setFieldValue(`${id}-13`, singleRadio);
            } else {
                setValue(undefined);
                form.setFieldValue(`${id}-13`, undefined);
            }
        }
    };

    // 多选搜索项列表选择
    const handleSearchChange = (e: any) => {
        console.log(value, 'changeChild');
        const val = e.target.value;
        if (isMultipleChoice) {
            let newVal = [];
            if (value.includes(val)) {
                newVal = value.filter((item: number) => item !== val);
            } else {
                newVal = [...value, val];
            }
            setValue(newVal);
            form.setFieldValue(`${id}-13`, newVal);
            setFormFields(newVal);

            // 搜索项手动更新表单缓存
            const localForm = localStorage.getItem('initFormData');
            let initForm: any = localForm ? JSON.parse(localForm) : {};
            initForm[`${id}-13`] = newVal;
            localStorage.setItem('initFormData', JSON.stringify(initForm));
        }
    };

    // 关闭按钮
    const handleClose = (removedTag: number, type?: string) => {
        let newTags = null;
        if (type) {
            setValue(newTags);
            form.setFieldValue(`${id}-13`, newTags);
        } else {
            newTags = value.filter((tag: number) => tag !== removedTag);
            setValue(newTags);
            form.setFieldValue(`${id}-13`, newTags);
            setFormFields(newTags);
        }

        // 搜索项手动更新表单缓存
        const localForm = localStorage.getItem('initFormData');
        let initForm: any = localForm ? JSON.parse(localForm) : {};
        initForm[`${id}-13`] = newTags;
        localStorage.setItem('initFormData', JSON.stringify(initForm));
    };

    // 变更校验
    const setFormFields = (newTags: []) => {
        if (required) {
            if (!newTags || (newTags && newTags.length === 0)) {
                form.setFields([{ name: `${id}-13`, errors: ['该题为必答题，请作答后提交'] }]);
            } else if (minSelect && newTags && newTags.length < minSelect) {
                form.setFields([{ name: `${id}-13`, errors: ['请您按题目要求作答'] }]);
            } else {
                form.setFields([{ name: `${id}-13`, errors: null }]);
            }
        } else {
            if (minSelect && newTags && newTags.length && newTags.length < minSelect) {
                form.setFields([{ name: `${id}-13`, errors: ['请您按题目要求作答'] }]);
            } else {
                form.setFields([{ name: `${id}-13`, errors: null }]);
            }
        }
    };

    // 获取选择选项name
    const getTagName = (valId: number) => {
        const name: any = optionList && optionList.length ? optionList.filter((item: any) => item.id === valId) : [];
        if (name && name.length) {
            return name[0].content;
        }
        return null;
    };

    // 搜索查询 - 多选
    const onSearchChange = (e: any) => {
        const val = e.target.value;
        const searchRes = optionList && optionList.filter((item: any) => item.content.toLowerCase().includes(val.toLowerCase()));
        setSearchOptions(searchRes);
    };

    // 搜索查询 - 单选
    const onSearchSingleChange = (e: any) => {
        const val = e.target.value;
        setSearchVal(val);
        const searchRes = optionList && optionList.filter((item: any) => item.content.toLowerCase().includes(val.toLowerCase()));
        setOptions(searchRes);
    };

    useEffect(() => {
        if (options && options.length) {
            if (location.pathname.includes('anwsersheets')) {
                let arr = options.filter((it: any) => it.selected);
                let answer: any = [];
                if (arr && arr.length) {
                    arr.forEach((el: any) => {
                        answer.push(el.id);
                    });
                    const resVal = isMultipleChoice ? answer : answer[0];
                    form.setFieldValue(`${id}-13`, resVal);
                    setValue(resVal);
                }
            } else {
                let formData = localStorage.getItem('initFormData');
                if (formData) {
                    let val = JSON.parse(formData)[`${id}-13`];
                    if (val) {
                        const resVal = isMultipleChoice ? val : val;
                        form.setFieldValue(`${id}-13`, resVal);
                        setValue(resVal);
                    }
                }
            }
        }
    }, [options]);

    useEffect(() => {
        if (optionList && optionList.length) {
            setOptions(optionList);
            setSearchOptions(optionList);
        }
    }, [optionList]);

    useEffect(() => {
        if (searchVal === '') {
            setOptions(optionList);
        }
    }, [searchVal]);

    return (
        <>
            <Form.Item
                name={`${id}-13`}
                className={`question-select-topic 
                    ${isMultipleChoice && value && value.length && 'select-multiple'}
                    ${!isMultipleChoice && value && 'select-multiple'}`}
                rules={[
                    {
                        required,
                        validator: async (rule, val) => {
                            if (required) {
                                if (!val || (val && val.length === 0) || (val && val.length === 1 && !val[0])) {
                                    throw '该题为必答题，请作答后提交。';
                                } else if (minSelect && val && val.length < minSelect) {
                                    throw '请您按题目要求作答';
                                } else if (maxSelect && val && val.length === maxSelect) {
                                } else {
                                }
                            } else {
                                if (minSelect && val && val.length && val.length < minSelect) {
                                    throw '请您按题目要求作答';
                                } else if (maxSelect && val && val.length && val.length === maxSelect) {
                                } else {
                                }
                            }
                        },
                    },
                ]}
                label={<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}
            >
                {isMultipleChoice ? (
                    <Checkbox.Group style={{ width: '100%', position: 'relative' }} value={value} onChange={handleChange}>
                        <Input autoComplete="off" maxLength={200} onChange={onSearchChange} placeholder="请输入您想搜索的内容" onFocus={() => setShowSearch(true)} allowClear prefix={<SearchOutlined style={{ color: '#999999' }} />} />
                        <Space
                            className="select-checkbox select-parent"
                            direction="vertical"
                            style={{
                                display: showSearch ? 'none' : 'block',
                            }}
                        >
                            {options && options.length
                                ? options.map((option: any) => (
                                      <div key={option.id}>
                                          <Checkbox value={option.id} disabled={maxSelect && isMultipleChoice && value.length >= maxSelect && !value.includes(option.id)}>
                                              {option.content}
                                          </Checkbox>
                                      </div>
                                  ))
                                : null}
                        </Space>
                        {searchOptions && searchOptions.length ? (
                            <Checkbox.Group style={{ width: '100%', display: showSearch ? 'block' : 'none', maxHeight: '150px', overflow: 'auto' }} value={value} className={`select-checkbox ${!(searchOptions && searchOptions.length) && 'no-after'}`}>
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    {searchOptions && searchOptions.length
                                        ? searchOptions.map((option: any) => (
                                              <div key={option.id}>
                                                  <Checkbox value={option.id} onChange={handleSearchChange} disabled={maxSelect && isMultipleChoice && value.length >= maxSelect && !value.includes(option.id)}>
                                                      {option.content}
                                                  </Checkbox>
                                              </div>
                                          ))
                                        : null}
                                </Space>
                            </Checkbox.Group>
                        ) : (
                            <div className="select-no-data slect-no-multiple">未找到匹配项，换个关键词试试</div>
                        )}
                    </Checkbox.Group>
                ) : (
                    <Radio.Group style={{ width: '100%' }} onChange={handleChange} value={value}>
                        <Input autoComplete="off" maxLength={200} value={searchVal} onChange={onSearchSingleChange} placeholder="请输入您想搜索的内容" prefix={<SearchOutlined style={{ color: '#999999' }} />} allowClear />
                        <Space direction="vertical" style={{ width: '100%' }} className={`select-checkbox ${!(options && options.length) && 'no-after'}`}>
                            {options && options.length ? (
                                options.map((option: any) => (
                                    <div key={option.id}>
                                        <Radio value={option.id}>{option.content}</Radio>
                                    </div>
                                ))
                            ) : (
                                <div className="select-no-data">未找到匹配项，换个关键词试试</div>
                            )}
                        </Space>
                    </Radio.Group>
                )}
            </Form.Item>
            {!!isMultipleChoice ? (
                <div className="select-tags">
                    {value && value.length
                        ? value.map((id: number) => (
                              <Tag
                                  key={id}
                                  closable
                                  onClose={e => {
                                      e.preventDefault();
                                      handleClose(id);
                                  }}
                              >
                                  <span className="select-tags-text">{getTagName(id)}</span>
                              </Tag>
                          ))
                        : null}
                </div>
            ) : (
                <div className="select-tags">
                    {(Array.isArray(value) && value.length) || (!Array.isArray(value) && value) ? (
                        <Tag
                            key={id}
                            closable
                            onClose={e => {
                                e.preventDefault();
                                handleClose(value, 'single');
                            }}
                        >
                            <span className="select-tags-text">{!!(optionList && optionList.length) && getTagName(value)}</span>
                        </Tag>
                    ) : null}
                </div>
            )}
        </>
    );
};

export default SelectList;
